import { render, staticRenderFns } from "./InBody.vue?vue&type=template&id=4631440b&scoped=true&"
import script from "./InBody.vue?vue&type=script&setup=true&lang=js&"
export * from "./InBody.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4631440b",
  null
  
)

export default component.exports